/**
 * A wrapper for an individual datum (usually part of a time series)
 */
export class Datum extends Object {
  /**
   * Initialize a Datum pair with an Index and Value
   * 
   * @param {Any} index Index of the Datum
   * @param {Any} value Value of the Datum
   */
  constructor(index, value) {
    super();
    this.index = index;
    this.value = value;
  }
}